import React from 'react';

const VideoAd = () => (
	<div style={{ maxWidth: '100%', textAlign: 'center' }}>
		<div id="waldo-tag-14865"></div>
	</div>
);
export default VideoAd;
